/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Api
 * Recipe Binder Digitizer API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * Returns server health status
 * @summary Health check
 */
export const HealthCheckResponse = zod.object({
  "status": zod.string()
})


/**
 * @summary List all images
 */
export const ListImagesQueryParams = zod.object({
  "batchId": zod.coerce.string().optional()
})

export const ListImagesResponse = zod.object({
  "images": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "filePath": zod.string(),
  "uploadBatch": zod.string().nullish(),
  "groupId": zod.int().nullish(),
  "groupOrder": zod.int().nullish(),
  "status": zod.enum(['pending', 'processing', 'extracted', 'validated', 'error']),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.date().nullish()
}))
})


/**
 * @summary Upload images
 */
export const UploadImagesBody = zod.object({
  "images": zod.array(zod.instanceof(Blob)),
  "batchId": zod.string().optional()
})

export const UploadImagesResponse = zod.object({
  "uploaded": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "filePath": zod.string(),
  "uploadBatch": zod.string().nullish(),
  "groupId": zod.int().nullish(),
  "groupOrder": zod.int().nullish(),
  "status": zod.enum(['pending', 'processing', 'extracted', 'validated', 'error']),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.date().nullish()
})),
  "batchId": zod.string()
})


/**
 * @summary Group images as multi-page recipe
 */
export const groupImagesBodyImageIdsMin = 2;
export const groupImagesBodyImageIdsMax = 10;



export const GroupImagesBody = zod.object({
  "imageIds": zod.array(zod.int()).min(groupImagesBodyImageIdsMin).max(groupImagesBodyImageIdsMax)
})

export const GroupImagesResponse = zod.object({
  "groupId": zod.int(),
  "images": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "filePath": zod.string(),
  "uploadBatch": zod.string().nullish(),
  "groupId": zod.int().nullish(),
  "groupOrder": zod.int().nullish(),
  "status": zod.enum(['pending', 'processing', 'extracted', 'validated', 'error']),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.date().nullish()
}))
})


/**
 * @summary Ungroup images by group ID
 */
export const UngroupImagesParams = zod.object({
  "groupId": zod.coerce.number().int()
})

export const UngroupImagesResponse = zod.object({
  "success": zod.boolean()
})


/**
 * @summary Get extraction status counts
 */
export const GetExtractionStatusResponse = zod.object({
  "pending": zod.int(),
  "processing": zod.int(),
  "extracted": zod.int(),
  "validated": zod.int(),
  "error": zod.int(),
  "total": zod.int(),
  "totalRecipes": zod.int(),
  "errors": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "errorMessage": zod.string().nullish()
})),
  "queueDepth": zod.object({
  "queued": zod.int().describe('Jobs waiting to be picked up by a worker.'),
  "active": zod.int().describe('Jobs currently being processed.')
}).optional().describe('Live snapshot of the persistent extraction job queue.')
})


/**
 * Returns immediately with a job id; clients should poll
 * `/extract/job/{jobId}` for completion and the resulting recipe ids.
 * @summary Enqueue extraction of a single image or group
 */
export const ExtractImageBody = zod.object({
  "imageId": zod.int()
})

export const ExtractImageResponse = zod.object({
  "success": zod.boolean(),
  "recipesExtracted": zod.int().describe('Always 0 — the job runs in the background.'),
  "recipeIds": zod.array(zod.int()).optional(),
  "jobId": zod.string().optional(),
  "queued": zod.boolean().optional().describe('false if a job for this image was already in flight.'),
  "error": zod.string().optional()
})


/**
 * @summary Poll the status of an enqueued extraction job
 */
export const GetExtractionJobParams = zod.object({
  "jobId": zod.coerce.string()
})

export const GetExtractionJobResponse = zod.object({
  "state": zod.enum(['created', 'retry', 'active', 'completed', 'cancelled', 'failed']),
  "retryCount": zod.int(),
  "recipesExtracted": zod.int().describe('0 until the job completes; final count when state=completed.'),
  "recipeIds": zod.array(zod.int()).describe('Empty until the job completes; recipe ids on success.'),
  "error": zod.string().optional()
}).describe('Status of an enqueued extraction job (polled by the client).')


/**
 * @summary Start batch extraction of all pending images
 */
export const BatchExtractResponse = zod.object({
  "started": zod.boolean(),
  "queued": zod.int()
})


/**
 * @summary Reset all error images to pending and start batch extraction
 */
export const RetryAllErrorsResponse = zod.object({
  "started": zod.boolean(),
  "queued": zod.int()
})


/**
 * @summary Re-enqueue extraction for a failed image
 */
export const RetryExtractionParams = zod.object({
  "imageId": zod.coerce.number().int()
})

export const RetryExtractionResponse = zod.object({
  "success": zod.boolean(),
  "recipesExtracted": zod.int().describe('Always 0 — the retry runs in the background.'),
  "jobId": zod.string().optional(),
  "queued": zod.boolean().optional(),
  "error": zod.string().optional()
})


/**
 * @summary Bulk update validation status for multiple recipes
 */
export const BulkUpdateStatusBody = zod.object({
  "ids": zod.array(zod.int()),
  "validationStatus": zod.string()
})

export const BulkUpdateStatusResponse = zod.object({
  "updated": zod.int()
})


/**
 * @summary Bulk delete multiple recipes
 */
export const BulkDeleteRecipesBody = zod.object({
  "ids": zod.array(zod.int())
})

export const BulkDeleteRecipesResponse = zod.object({
  "deleted": zod.int()
})


/**
 * @summary List all recipe categories with counts
 */
export const ListRecipeCategoriesResponse = zod.object({
  "categories": zod.array(zod.object({
  "category": zod.string(),
  "count": zod.int()
}))
})


/**
 * @summary List all extracted recipes
 */
export const listRecipesQueryMaxPrepMinutesMin = 0;

export const listRecipesQueryMaxCookMinutesMin = 0;



export const ListRecipesQueryParams = zod.object({
  "validationStatus": zod.coerce.string().optional(),
  "search": zod.coerce.string().optional().describe('Full-text search across title, author, cuisine, directions, notes, and ingredients'),
  "sort": zod.enum(['alpha', 'date', 'oldest', 'exif']).optional().describe('Sort order — alpha=A-Z by title, date=newest first, oldest=oldest first, exif=capture time (default)'),
  "tag": zod.array(zod.coerce.string()).optional().describe('Filter by tag slug. Repeatable; multiple tags AND together (intersection).'),
  "maxPrepMinutes": zod.coerce.number().int().min(listRecipesQueryMaxPrepMinutesMin).optional().describe('Only return recipes whose parsed prep time is ≤ this many minutes'),
  "maxCookMinutes": zod.coerce.number().int().min(listRecipesQueryMaxCookMinutesMin).optional().describe('Only return recipes whose parsed cook time is ≤ this many minutes'),
  "calMin": zod.coerce.number().optional(),
  "calMax": zod.coerce.number().optional(),
  "proteinMin": zod.coerce.number().optional(),
  "proteinMax": zod.coerce.number().optional(),
  "carbsMin": zod.coerce.number().optional(),
  "carbsMax": zod.coerce.number().optional(),
  "fatMin": zod.coerce.number().optional(),
  "fatMax": zod.coerce.number().optional()
})

export const ListRecipesResponse = zod.object({
  "recipes": zod.array(zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}))
})


/**
 * @summary List all known tags (starter + user-created) with usage counts
 */
export const ListTagsResponse = zod.object({
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string(),
  "isStarter": zod.boolean(),
  "count": zod.int()
}))
})


/**
 * @summary Merge otherId recipe into id recipe (otherId is deleted, id survives)
 */
export const MergeRecipesParams = zod.object({
  "id": zod.coerce.number().int(),
  "otherId": zod.coerce.number().int()
})

export const MergeRecipesResponse = zod.object({
  "success": zod.boolean(),
  "recipe": zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))
})


/**
 * @summary Split selected ingredients off into a new recipe
 */
export const SplitRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const SplitRecipeBody = zod.object({
  "newTitle": zod.string().optional().describe('Optional title for the new duplicate recipe; defaults to original title + " (2)"')
})

export const SplitRecipeResponse = zod.object({
  "original": zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
})),
  "newRecipe": zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))
})


/**
 * @summary Get a single recipe with full detail
 */
export const GetRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const GetRecipeResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary Update recipe fields and/or ingredients
 */
export const UpdateRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const UpdateRecipeBody = zod.object({
  "title": zod.string().optional(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string().optional(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string().nullish(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "ingredients": zod.array(zod.object({
  "sortOrder": zod.int().nullish(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).nullish(),
  "tags": zod.array(zod.string()).nullish().describe('Tag slugs (or display names; will be slugified). Replaces the recipe\'s full tag set when present.')
})

export const UpdateRecipeResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary Delete a recipe
 */
export const DeleteRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const DeleteRecipeResponse = zod.object({
  "success": zod.boolean()
})


/**
 * @summary Mark recipe as validated
 */
export const ValidateRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const ValidateRecipeResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary Mark recipe as needs_correction
 */
export const FlagRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const FlagRecipeResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary Re-run AI extraction, overwriting current recipe data in-place
 */
export const ReextractRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const ReextractRecipeResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary List the current household's favorite recipes (newest first)
 */
export const ListFavoritesResponse = zod.object({
  "recipes": zod.array(zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}))
})


/**
 * @summary Mark a recipe as favorite (idempotent)
 */
export const AddFavoriteParams = zod.object({
  "recipeId": zod.coerce.number().int()
})

export const AddFavoriteResponse = zod.object({
  "recipeId": zod.int(),
  "isFavorite": zod.boolean()
})


/**
 * @summary Remove a recipe from favorites (idempotent)
 */
export const RemoveFavoriteParams = zod.object({
  "recipeId": zod.coerce.number().int()
})

export const RemoveFavoriteResponse = zod.object({
  "recipeId": zod.int(),
  "isFavorite": zod.boolean()
})


/**
 * @summary List all favorite collections (with recipe counts)
 */
export const ListFavoriteCollectionsResponse = zod.object({
  "collections": zod.array(zod.object({
  "id": zod.int(),
  "name": zod.string(),
  "recipeCount": zod.int(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish()
}))
})


/**
 * @summary Create a new favorite collection
 */
export const createFavoriteCollectionBodyNameMax = 100;



export const CreateFavoriteCollectionBody = zod.object({
  "name": zod.string().min(1).max(createFavoriteCollectionBodyNameMax)
})

export const CreateFavoriteCollectionResponse = zod.object({
  "id": zod.int(),
  "name": zod.string(),
  "recipeCount": zod.int(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish()
})


/**
 * @summary Get one collection with its recipes
 */
export const GetFavoriteCollectionParams = zod.object({
  "collectionId": zod.coerce.number().int()
})

export const GetFavoriteCollectionResponse = zod.object({
  "collection": zod.object({
  "id": zod.int(),
  "name": zod.string(),
  "recipeCount": zod.int(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish()
}),
  "recipes": zod.array(zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}))
})


/**
 * @summary Rename a favorite collection
 */
export const UpdateFavoriteCollectionParams = zod.object({
  "collectionId": zod.coerce.number().int()
})

export const updateFavoriteCollectionBodyNameMax = 100;



export const UpdateFavoriteCollectionBody = zod.object({
  "name": zod.string().min(1).max(updateFavoriteCollectionBodyNameMax)
})

export const UpdateFavoriteCollectionResponse = zod.object({
  "id": zod.int(),
  "name": zod.string(),
  "recipeCount": zod.int(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish()
})


/**
 * @summary Delete a favorite collection (recipes themselves are not deleted)
 */
export const DeleteFavoriteCollectionParams = zod.object({
  "collectionId": zod.coerce.number().int()
})

export const DeleteFavoriteCollectionResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Add a recipe to a collection (idempotent)
 */
export const AddRecipeToFavoriteCollectionParams = zod.object({
  "collectionId": zod.coerce.number().int(),
  "recipeId": zod.coerce.number().int()
})

export const AddRecipeToFavoriteCollectionResponse = zod.object({
  "collectionId": zod.int(),
  "recipeId": zod.int()
})


/**
 * @summary Remove a recipe from a collection (idempotent)
 */
export const RemoveRecipeFromFavoriteCollectionParams = zod.object({
  "collectionId": zod.coerce.number().int(),
  "recipeId": zod.coerce.number().int()
})

export const RemoveRecipeFromFavoriteCollectionResponse = zod.object({
  "collectionId": zod.int(),
  "recipeId": zod.int()
})


/**
 * @summary List collections that contain a given recipe
 */
export const ListCollectionsForRecipeParams = zod.object({
  "id": zod.coerce.number().int()
})

export const ListCollectionsForRecipeResponse = zod.object({
  "collectionIds": zod.array(zod.int())
})


/**
 * @summary Upload or replace the hero photo for a recipe
 */
export const UploadHeroImageParams = zod.object({
  "id": zod.coerce.number().int()
})

export const UploadHeroImageBody = zod.object({
  "image": zod.instanceof(Blob)
})

export const UploadHeroImageResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


/**
 * @summary Remove the hero photo from a recipe
 */
export const DeleteHeroImageParams = zod.object({
  "id": zod.coerce.number().int()
})

export const DeleteHeroImageResponse = zod.object({
  "id": zod.int(),
  "title": zod.string(),
  "authorSource": zod.string().nullish(),
  "category": zod.string().nullish(),
  "cuisine": zod.string().nullish(),
  "prepTime": zod.string().nullish(),
  "cookTime": zod.string().nullish(),
  "totalTime": zod.string().nullish(),
  "yieldServings": zod.string().nullish(),
  "difficulty": zod.string().nullish(),
  "directions": zod.string(),
  "servingSuggestions": zod.string().nullish(),
  "handwrittenNotes": zod.string().nullish(),
  "transcriberNotes": zod.string().nullish(),
  "sourceType": zod.string().nullish(),
  "validationStatus": zod.string(),
  "potentialDuplicateOfId": zod.int().nullish(),
  "potentialDuplicateTitle": zod.string().nullish(),
  "heroImagePath": zod.string().nullish(),
  "heroImageOriginalName": zod.string().nullish(),
  "featured": zod.boolean().nullish(),
  "caloriesPerServing": zod.int().nullish(),
  "isFavorite": zod.boolean().nullish(),
  "createdAt": zod.date().nullish(),
  "updatedAt": zod.date().nullish(),
  "ingredients": zod.array(zod.object({
  "id": zod.int(),
  "recipeId": zod.int(),
  "sortOrder": zod.int(),
  "amount": zod.string().nullish(),
  "unit": zod.string().nullish(),
  "item": zod.string(),
  "prepNotes": zod.string().nullish(),
  "sectionHeader": zod.string().nullish()
})).optional(),
  "tags": zod.array(zod.object({
  "slug": zod.string(),
  "name": zod.string()
})).optional()
}).and(zod.object({
  "sourceImages": zod.array(zod.object({
  "id": zod.int(),
  "filename": zod.string(),
  "originalName": zod.string(),
  "url": zod.string(),
  "isPrimary": zod.boolean()
}))
}))


